<div class="row">
  <div class="col">
    <h3>{{ 'i18n.domain.incidents.overview.title' | translate }}</h3>
  </div>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
      <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]="showInactive" cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
    class="grid-with-toolbar"
    width='100%'
    rowHeight='38'
    [dataSource]='data'
    [allowSorting]='true'
    [filterSettings]='filterSettings'
    [allowFiltering]='true'
    [allowPaging]='true'
    [pageSettings]='pageSettings'
    [editSettings]='editSettings'
    [searchSettings]="searchOptions"
    (actionBegin)="actionBegin($event)"
    (actionComplete)="actionComplete($event)"
    (rowDataBound)="onRowDataBound($event)">
    <ng-template #toolbarTemplate let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.incidents.overview.add' | translate" prefixIcon='e-icons icon-add' (click)="onAdd()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field='id'
        [visible]='false'
        headerText='ID'
        [isPrimaryKey]='true'></e-column>
      <e-column field='statusServiceName'
        type="string"
        headerText="{{'i18n.domain.incidents.fields.service' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='status'
        headerText="{{'i18n.domain.incidents.fields.status' | translate}}">
        <ng-template #template let-data>
          {{formatStatus(data)}}
        </ng-template>
      </e-column>
      <e-column field='sendNotification'
        headerText="{{'i18n.domain.incidents.fields.sendNotification' | translate}}">
        <ng-template #template let-data>
          {{formatBoolean(data, 'sendNotification')}}
        </ng-template>
      </e-column>
      <e-column field='createdOn'
        type="date"
        headerText="{{'i18n.domain.incidents.fields.createdOn' | translate}}"
        format='dd.MM.yyyy HH:mm'>
      </e-column>
      <e-column [headerText]="'i18n.shared.fields.active' | translate" field="isDeleted" [visible]='showInactive'>
        <ng-template #template let-data>
          @if (!data.isDeleted) {
            <div class="e-icons icon-checkmark align-middle"></div>
          }
        </ng-template>
      </e-column>
      <e-column headerText="" [commands]='gridCommands' textAlign='Right'></e-column>
    </e-columns>
    <ng-template #editSettingsTemplate let-data>
      <app-incident-edit-form
        [incidentEditForm]="gridEditForm"
        [serviceDropdownItems]="serviceDropdownItems"
        [isReadOnly]="!!data.id"
        (languagesChanged)="onLanguagesChanged($event)">
      </app-incident-edit-form>
    </ng-template>
  </ejs-grid>
</div>
